import { render, staticRenderFns } from "./ReportBalance.vue?vue&type=template&id=35b4aaee&scoped=true"
import script from "./ReportBalance.vue?vue&type=script&lang=js"
export * from "./ReportBalance.vue?vue&type=script&lang=js"
import style0 from "./ReportBalance.vue?vue&type=style&index=0&id=35b4aaee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b4aaee",
  null
  
)

export default component.exports